'use client'

// React Imports
import { useMemo } from 'react'

// MUI Imports
import Grid from '@mui/material/Grid'

// Component Imports
import PhysicalAppointmentListWrapper from './PhysicalAppointmentListWrapper'

const PhysicalAppointmentList = ({
    data,
    searchTerm,
    stats,
    loading,
    onEditAppointment,
    onRemoveAppointment,
    onViewAppointment,
    onMarkCompleted,
    onViewLead,
    onRefresh,
    onAddComment,
    currentPage,
    onPageChange,
    itemsPerPage,
    crmOperationPerms
}) => {
    return (
        <PhysicalAppointmentListWrapper
            data={data}
            searchTerm={searchTerm}
            stats={stats}
            loading={loading}
            onEditAppointment={onEditAppointment}
            onRemoveAppointment={onRemoveAppointment}
            onViewAppointment={onViewAppointment}
            onMarkCompleted={onMarkCompleted}
            onViewLead={onViewLead}
            onRefresh={onRefresh}
            onAddComment={onAddComment}
            currentPage={currentPage}
            onPageChange={onPageChange}
            itemsPerPage={itemsPerPage}
            crmOperationPerms={crmOperationPerms}
        />
    )
}

export default PhysicalAppointmentList
